import slugify from 'slugify';
import { LocationItem } from '../../../types/search';
import { LocationSegment, LocalizedLabel } from '../../../types/locationSegment';

export const toSlug = (text: string): string =>
  slugify(text, {
    lower: true,
    locale: 'th',
    remove: /[*+~.()'"!:@]/g,
  });

export const createSegmentFromItem = (
  item: LocationItem,
  locale: string = 'th'
): LocationSegment => {
  const label: LocalizedLabel = {
    th: item.originalLabel || item.label,
    en: item.label,
    cn: item.label,
  } as LocalizedLabel;

  return {
    id: item.value,
    label,
    slug: toSlug(label[locale as keyof LocalizedLabel] || label.th),
  };
};

export const segmentsToDisplayString = (
  segments: LocationSegment[],
  locale: string = 'th'
): string => segments.map((s) => s.label[locale as keyof LocalizedLabel]).join(' - ');

export const segmentsToPathArray = (
  segments: LocationSegment[],
  locale: string = 'th'
): string[] => segments.map((s) => (locale === 'th' ? s.slug : toSlug(s.label[locale as keyof LocalizedLabel]))); 